import React from 'react';

const InputComponent = ({ label, type, value, onChange, readOnly, defaultValue, required, checked }) => {
  if (type === 'checkbox') {
    return (
      <div className="form-checkbox-wrap">
        <input
          id={`chk-${label}`}
          type="checkbox"
          className="form-checkbox"
          checked={checked || false}
          onChange={onChange}
          readOnly={readOnly}
        />
        <label htmlFor={`chk-${label}`} className="form-checkbox-label">
          {label}
        </label>
      </div>
    );
  }

  return (
    <>
      <label className="form-label">
        {label}
        {required && <span className="req">*</span>}
      </label>
      <input
        type={type || 'text'}
        className="form-input"
        value={value}
        onChange={onChange}
        readOnly={readOnly}
        defaultValue={defaultValue}
        required={required}
      />
    </>
  );
};

export default InputComponent;
